import { memo, useMemo, useState } from 'react'
import ReactModal from 'react-modal'
import { useLiveMonitor } from '../../../../Hooks/useLiveMonitor'
import { useTranslation } from 'react-i18next'
import styles from './../../LiveMonitor.module.css'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { ListData, ListDataProps } from '../../Cards/ListData'
import { useLocation } from 'wouter'
import { useTeam } from '../../../../Hooks/useTeam'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { defaultModalStyles } from '../../../../../../constants'

export const TeamsTagsCard = memo(() => {
    const { t } = useTranslation('teamMonitor')
    const [detailsTag, setDetailsTag] = useState<tag>()
    const { stats } = useLiveMonitor()
    const teamTags = stats?.monitor?.teamTags

    const items: ListDataProps['items'] = useMemo(
        () =>
            teamTags?.map((item) => {
                const { tags, teams } = item
                const title = `${t('Teams')}: ${teams.join(', ')}`
                return {
                    icon: {
                        icon: ['fas', 'tags'] as IconProp,
                        style: { color: 'inherit' },
                    },
                    label: {
                        text: tags.join(', '),
                        style: { color: 'inherit' },
                        title,
                        onClick: () => setDetailsTag(item),
                    },
                    value: {
                        text: teams.length,
                        style: { color: 'inherit' },
                        title,
                        onClick: () => setDetailsTag(item),
                    },
                }
            }),
        [teamTags, t]
    )

    if (!teamTags || !teamTags.length) return null

    const info = t(
        'This card displays all existing tags and, alongside each one, the number of associated teams. Clicking on an item opens a modal with details of the teams corresponding to the selected tags.'
    )

    return (
        <>
            <ListData title={t('Teams by Tag')} items={items} info={info} />
            {detailsTag && <Modal isOpen={!!detailsTag} tag={detailsTag} closeModal={() => setDetailsTag(null)} />}
        </>
    )
})

const Modal = ({
    isOpen,
    closeModal,
    tag,
}: {
    isOpen: boolean
    closeModal: () => void
    tag: {
        tags: string[]
        teams: number[]
    }
}) => {
    const { t } = useTranslation('teamMonitor')
    const [, setLocation] = useLocation()
    const { courseID } = useTeam()

    return (
        <ReactModal isOpen={isOpen} style={defaultModalStyles}>
            <FontAwesomeIcon icon={['fas', 'times']} onClick={closeModal} className={styles.closeIcon} />
            <div className={styles.modal}>
                <h4>
                    <FontAwesomeIcon icon={['fas', 'tags']} style={{ marginRight: 10 }} />
                    {`${t(`Teams with the tags`)}: ${tag.tags.join(', ')}`}
                </h4>
                <div className={styles.table}>
                    {tag.teams.map((team) => (
                        <div
                            key={team}
                            className={styles.talkingQualityRow}
                            onClick={() => setLocation(`/admin/team/${courseID}?searchType=teams&searchQuery=${team}`)}
                        >
                            <div className={styles.talkingQualityItem}>
                                <p className={styles.buttonTitle}>
                                    {t('Team')} {team}
                                </p>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </ReactModal>
    )
}

type tag = {
    tags: string[]
    teams: number[]
}
